import customBlocks from 'volto-lanku/components/customBlocks';
import BertsolariaView from 'volto-lanku/components/Views/BertsolariaView';
const applyConfig = (config) => {
  config.settings = {
    ...config.settings,
    nonContentRoutes: [...config.settings.nonContentRoutes],
    defaultLanguage: 'eu',
    querystringSearchGet: true,
    registry: {
      ...config.settings.registry,
    },

    showTags: false,
    pictureOptions: {
      grid: [
        { media: '(min-width: 1200px)', image: 'huge' },
        {
          media: '(min-width: 992px) and (max-width: 1199px)',
          image: 'larger',
        },
        { media: '(max-width: 991px)', image: 'large' },
      ],
      eskaintza: [
        { media: '(min-width: 1200px)', image: 'huge' },
        {
          media: '(min-width: 992px) and (max-width: 1199px)',
          image: 'larger',
        },
        { media: '(max-width: 991px)', image: 'large' },
      ],
      eskaintzagrid: [
        { media: '(min-width: 1200px)', image: 'larger' },
        {
          media: '(max-width: 1199px)',
          image: 'large',
        },
      ],
      newsitem: [
        { media: '(min-width: 1200px)', image: 'larger' },
        {
          media: '(min-width: 1199px)',
          image: 'large',
        },
      ],
    },
  };
  config.settings.asyncPropsExtenders = [
    ...(config.settings.asyncPropsExtenders || []),
    {
      path: '/',
      extend: (dispatchActions) => {
        const baztertzekoGakoak = [
          'breadcrumbs',
          'navigation',
          'actions',
          'types',
          'workflow',
          'navroot',
          'dropdownMenuNavItems',
        ];

        return dispatchActions.filter(
          (asyncAction) => !baztertzekoGakoak.includes(asyncAction.key),
        );
      },
    },
  ];
  config.settings.apiExpanders = config.settings.apiExpanders
    .map((expander) => {
      if (expander.GET_CONTENT) {
        return {
          ...expander,
          GET_CONTENT: expander.GET_CONTENT.filter(
            (item) =>
              ![
                'breadcrumbs',
                'navigation',
                'actions',
                'types',
                'navroot',
              ].includes(item),
          ),
        };
      }
      return expander;
    })
    .filter((expander) => {
      if (expander.GET_CONTENT && expander.GET_CONTENT.length === 0) {
        return false;
      }
      return true;
    });
  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,
    ...customBlocks(config),
  };
  // This disables the Volto core grid block
  config.blocks.blocksConfig.gridBlock.restricted = true;
  config.views = {
    ...config.views,
    contentTypesViews: {
      ...config.views.contentTypesViews,
      Bertsolaria: BertsolariaView,
    },
  };

  return config;
};
export default applyConfig;
